import React, { Fragment } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { object, array, bool, string } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import ViewAll from './Components/ViewAll'
import Post from '../Post/Post'

function Section({
  posts = EMPTY_ARRAY,
  category = null,
  isMainPage = false,
  isRelatedPost = false,
  centered = false,
  title: propTitle = '',
  responsive = false,
}) {
  const { title, slug } = category || {}
  const hasPosts = !!posts.length

  function getPostLayout() {
    return isMainPage || isRelatedPost ? 'vertical' : 'horizontal'
  }

  function getPostContent(post) {
    const layout = getPostLayout()

    if (isRelatedPost) {
      const { attributes } = post || {}

      return (
        <Post titleComponent="h3" layout={layout} {...attributes} />
      )
    }

    return (
      <Post
        titleComponent="h3"
        layout={layout}
        {...post}
      />
    )
  }

  function getSectionTitle(variant, style, text) {
    const CustomTag = `${variant}`
    const titleStyle = `cgt-heading-${style}`

    return <CustomTag className={titleStyle}>{text}</CustomTag>
  }

  const titleComponent = isMainPage || isRelatedPost ? 'h2' : 'h1'
  const titleStyle = 'h3'

  return (
    <Fragment>
      <div
        className={classnames(
          'blog-section-title cgt-mb-20',
          centered && 'blog-section-title--centered'
        )}
      >
        {getSectionTitle(titleComponent, titleStyle, propTitle || title)}

        {hasPosts && isMainPage && <ViewAll slug={slug} />}
      </div>

      {!hasPosts && <h3>No posts</h3>}

      {hasPosts && (
        <div className="row blog-posts blog-posts--section">
          {posts.map((post, index) => {
            return (
              <div
                key={`section-post-${index}`}
                className={classnames(
                  'col-12',
                  (responsive || isMainPage) && 'col-sm-6 col-md-4',
                )}
              >
                {getPostContent(post)}
              </div>
            )
          })}
        </div>
      )}
    </Fragment>
  )
}

Section.propTypes = {
  posts: array,
  category: object,
  isMainPage: bool,
  isRelatedPost: bool,
  centered: bool,
  responsive: bool,
  title: string,
}

export default Section
